<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px">
    <el-form-item label="上级部门" prop="fParentID">
      <el-select-tree
        v-model="form.fParentID"
        url="SystemApplication/Dept/DeptTree"
        node-key="fDeptID"
        panel-width="100%"
        style="width:100%"
        :extraParam="{ filterDeptID: filterDeptID }"
      />
    </el-form-item>
    <el-form-item label="部门名称" prop="fName">
      <el-input v-model="form.fName" />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fName: [{ required: true, message: '必填项', trigger: 'change' }],
        fParentID: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    }
  },
  computed: {
    filterDeptID: function(){
      const deptId = this.form.fDeptID;
      return deptId ? deptId :  null;
    }
  }
}
</script>

<style>

</style>
